import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { WidgetContent } from '../WidgetContent/WidgetContent';
import { WidgetsDTO } from '../../../../api/useWidgetsQuery';
import { DesktopPageWrapper } from '../../../../AccountPerformanceReporting.styles';
import { WIDGETS_WITH_GROUP_SELECTION } from '../../DesktopWidgets.meta';

interface Props {
  widgets: WidgetsDTO;
}

export const Widgets = ({ widgets, ...rest }: Props) => {
  return (
    <DesktopPageWrapper>
      {widgets.included.map(({ id, title, isFullWidth }) => (
        <Box
          css={{
            gridColumn: isFullWidth ? 'span 2' : 'unset',
          }}
        >
          {WIDGETS_WITH_GROUP_SELECTION.includes(id) && (
            <Box id={`group-selection--portal-target--${id}`} />
          )}

          <Box
            css={{
              position: 'relative',
              height: '100%',
              '> *': {
                height: '100%',
              },
            }}
          >
            <WidgetContent id={id} title={title} {...rest} />
          </Box>
        </Box>
      ))}
    </DesktopPageWrapper>
  );
};
